// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2iY_L","tab":"Tabs_tab__3oQbW","tabActive":"Tabs_tabActive__2p4LV"};